module.exports = __webpack_public_path__ + "static/media/StarLightGardensImg.43595416.png";